import { NEW_MESSAGE, RECEIVE_MESSAGE, SEND_MESSAGE } from "../actions/chatAction";

const initialState = [
	{
		id: 'bot-message',
		authorId: 'bot',
		text: 'Our Agent will be with you shortly.',
		timestamp: Date.now(),
	},
];


export default function(state = initialState, action) {
    switch(action.type) {
        case NEW_MESSAGE:
            if (action.payload.customId === 'VISITOR_CHAT_HISTORY') {
                return state
            }
            const foundEvent = state.filter(event => {
                return (
                    (event.customId && event.customId === action.payload.customId) || (event.id && event.id === action.payload.id)
                )
            })
            if (!foundEvent.length) {
                return [...state, action.payload]
            }
            return state;
        case SEND_MESSAGE:
            if (action.payload.customId === 'VISITOR_CHAT_HISTORY') {
                return state;
            }
            return [
                ...state,
                {
                    ...action.payload,
                    status: 'SENDING',
                    own: true,
                },
            ];
        case RECEIVE_MESSAGE:
            return [
                ...state,
                {
                    ...action.payload,
                    status: 'RECEIVING',
                    own: false,
                },
            ]
        default:
            return state;
    }
}

export const getEvents = state => state.events;